/* eslint-disable react/function-component-definition */
import React, { useState } from 'react'

// core components
import Button from 'src/components/sharedComponents/CustomButtons/Button'
import defaultImage from 'src/assets/images/image_placeholder.jpg'
import pdfImage from 'src/assets/images/pdfFile.png'
import excelImage from 'src/assets/images/excel.png'

const BASE_URL = 'https://lucia-static.lucia.com.co/'

export default function ImageUpload(props) {
  const {
    avatar,
    addButtonProps,
    changeButtonProps,
    removeButtonProps,
    captureImgBase64,
    imageDefault,
    stateEdit = false,
  } = props
  const [file, setFile] = useState(null)
  const [fileExt, setFileExt] = useState('')
  const [imagePreviewUrl, setImagePreviewUrl] = useState(
    imageDefault ? `${BASE_URL}${imageDefault}` : defaultImage,
  )
  const fileInput = React.createRef()

  const handleImageChange = (e) => {
    e.preventDefault()
    const reader = new FileReader()
    const file = e.target.files[0]
    setFileExt(file.name.split('.').pop())
    reader.onloadend = () => {
      setFile(file)
      setImagePreviewUrl(reader.result)
      if (props.onChange) {
        props.onChange(file)
      }
    }
    if (file) {
      reader.readAsDataURL(file)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    captureImgBase64({ archivo: imagePreviewUrl, tipo: fileExt })
    setFile(null)
  }
  const handleClick = () => {
    fileInput.current.click()
  }
  const handleRemove = () => {
    setFile(null)
    setImagePreviewUrl(defaultImage)
    fileInput.current.value = null
  }

  return (
    <div className="fileinput text-center">
      <input type="file" onChange={handleImageChange} ref={fileInput} />
      <div className="thumbnail">
        {fileExt === 'pdf' ? (
          <>
            <img src={pdfImage} alt="prevImg" />
          </>
        ) : fileExt == 'xlsx' ? (
          <>
            <img src={excelImage} alt="prevImg" />
          </>
        ) : (
          <>
            <img src={imagePreviewUrl} alt="prevImg" />
          </>
        )}
      </div>
      <div>
        {file === null ? (
          <Button {...addButtonProps} onClick={() => handleClick()}>
            Añadir
          </Button>
        ) : (
          <span>
            <Button {...changeButtonProps} onClick={() => handleClick()}>
              Cambiar
            </Button>
            {avatar ? <br /> : null}
            <Button {...removeButtonProps} onClick={() => handleRemove()}>
              <i className="fas fa-times" /> Remover
            </Button>
            <Button
              disabled={stateEdit}
              {...addButtonProps}
              onClick={handleSubmit}
            >
              Guardar
            </Button>
          </span>
        )}
      </div>
    </div>
  )
}
